// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"D0-z","sponsoredTooltipWrapper":"E0-z","sponsoredTooltip":"F0-z","newCard":"G0-z"};